
export const nav = {
  home: 'Home',
  assessment: 'Assessment',
  results: 'Results',
  pricing: 'Pricing',
  signIn: 'Sign In',
  signOut: 'Sign Out',
  dashboard: 'Dashboard',
  admin: 'Admin',
  support: 'Support',
  recruitment: 'Recruitment',
  orgChart: 'Org Chart',
  comparison: 'Talent Optimization',
  positions: 'Positions',
  profiles: 'Profiles',
  forms: 'Forms',
  funnel: 'Funnel',
  team: 'Team'
};
